export class Pagination {
  currentPage?: number;
  lastPage?: number;
  total?: number;
  perPage?: number;

  constructor(data: Partial<Pagination> = {}) {
    Object.assign(this, data)
  }

}